module.exports = __webpack_public_path__ + "img/zuo001.1f08d242.png";